var map = {
	"./ContributionGraph.jsx": 7141,
	"./HelloWorld.jsx": 5271,
	"./ModuleSelect.jsx": 9687,
	"./SegmentedBar.jsx": 1436,
	"components/ContributionGraph.jsx": 7141,
	"components/HelloWorld.jsx": 5271,
	"components/ModuleSelect.jsx": 9687,
	"components/SegmentedBar.jsx": 1436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2409;